export default __webpack_public_path__ + "static/media/triatlon.2a65eee2.avif";